(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["PJ_PromoBannerStrip"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__PJ_PROMO_STRIP__ && window.__PJ_PROMO_STRIP__.initialized) return;
  window.__PJ_PROMO_STRIP__ = { version: 'inline-v1', initialized: true };

  const SWIPE_THRESHOLD = 40;

  class PromoBannerStrip extends HTMLElement {
    connectedCallback() {
      this.activeIndex = 0;
      this.track = this.querySelector('[data-promo-track]');
      this.viewport = this.querySelector('[data-promo-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-promo-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-promo-dot]'));
      this.prevBtn = this.querySelector('[data-promo-prev]');
      this.nextBtn = this.querySelector('[data-promo-next]');

      if (!this.track || this.slides.length === 0) return;
      if (this.slides.length <= 1) return;

      this.touchStartX = null;
      this.touchEndX = null;

      this.bindEvents();
      this.update();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.goTo(this.activeIndex - 1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.goTo(this.activeIndex + 1));
      }
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.promoIndex || '0', 10);
          this.goTo(index);
        });
      });

      if (this.viewport) {
        this.viewport.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0].clientX;
          this.touchEndX = null;
        }, { passive: true });

        this.viewport.addEventListener('touchmove', (event) => {
          this.touchEndX = event.changedTouches[0].clientX;
        }, { passive: true });

        this.viewport.addEventListener('touchend', () => {
          if (this.touchStartX === null || this.touchEndX === null) {
            this.touchStartX = null;
            this.touchEndX = null;
            return;
          }
          const delta = this.touchStartX - this.touchEndX;
          if (Math.abs(delta) >= SWIPE_THRESHOLD) {
            this.goTo(this.activeIndex + (delta > 0 ? 1 : -1));
          }
          this.touchStartX = null;
          this.touchEndX = null;
        });
      }
    }

    goTo(index) {
      const total = this.slides.length;
      this.activeIndex = ((index % total) + total) % total;
      this.update();
    }

    update() {
      if (this.track) {
        this.track.style.transform = 'translateX(-' + (this.activeIndex * 100) + '%)';
      }
      this.dots.forEach((dot, i) => {
        const active = i === this.activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', i === this.activeIndex ? 'false' : 'true');
      });
    }
  }

  if (!customElements.get('promo-banner-strip')) {
    customElements.define('promo-banner-strip', PromoBannerStrip);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
